import GeoFencingService from "@/services/GeoFencingService";

let inFlightPromise = null;

export default {
  namespaced: true,

  state: () => ({
    globalStatus: 0, // 0 or 1
    loaded: false, // 🔑 important
  }),

  mutations: {
    SET_GLOBAL_STATUS(state, status) {
      state.globalStatus = Number(status) === 1 ? 1 : 0;
    },
    SET_LOADED(state, value) {
      state.loaded = value;
    },
  },

  actions: {
    async fetchGlobalStatus({ state, commit }, { forceRefresh = false } = {}) {
      if (state.loaded && !forceRefresh) return state.globalStatus;

      if (inFlightPromise) return inFlightPromise;

      inFlightPromise = GeoFencingService.getGlobalGeofenceStatus()
        .then((status) => {
          commit("SET_GLOBAL_STATUS", status);
          return state.globalStatus;
        })
        .catch(() => {
          commit("SET_GLOBAL_STATUS", 0);
          return 0;
        })
        .finally(() => {
          commit("SET_LOADED", true);
          inFlightPromise = null;
        });

      return inFlightPromise;
    },

    async updateGlobalStatus({ commit }, { hasGeofence, googleKey } = {}) {
      await GeoFencingService.updateGlobalGeofenceStatus(hasGeofence, googleKey);
      commit("SET_GLOBAL_STATUS", hasGeofence);
      commit("SET_LOADED", true);
    },
  },

  getters: {
    isEnabled: (state) => state.globalStatus === 1,
  },
};
